const RECOVERABLE_CLIENT_ERROR_PATTERNS = [
  /ChunkLoadError/i,
  /Loading chunk \d+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /Minified React error #185/i,
  /Maximum update depth exceeded/i,
];

export function isRecoverableClientStartupError(error: unknown): boolean {
  const errorName =
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    typeof error.name === "string"
      ? error.name
      : "";
  const errorMessage =
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string"
      ? error.message
      : typeof error === "string"
        ? error
        : "";
  const combined = `${errorName}: ${errorMessage}`;

  return RECOVERABLE_CLIENT_ERROR_PATTERNS.some((pattern) =>
    pattern.test(combined),
  );
}
